<template>
  <v-layout row wrap class="ma-0">
    <v-flex xs12>

    <v-toolbar flat :color="tarjasSelected.length == 0 ? 'secondary darken-3':'green  darken-2'" dark dense class="text-align-left">





      <template v-if="tarjasSelected.length <= 0">
        <v-toolbar-items>

          <v-btn icon color="white" @click="changeDate(-1)" :disabled="loadingDate" :loading="loadingPrevtDate">
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <v-btn icon color="white" @click="changeDate(1)" :disabled="loadingDate" :loading="loadingNextDate">
            <v-icon>chevron_right</v-icon>
          </v-btn>


          <v-menu
            offset-y
            v-model="dateMenu"
            :disabled="loadingDate"
            :close-on-content-click="false"
            transition="scale-transition"
            full-width
            min-width="290px"
          >

            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text color="white" :disabled="loadingDate" class="" >
                <v-icon class="mr-3">today</v-icon>
                {{dateSelectedFormated}}
              </v-btn>
            </template>

            <v-date-picker
            v-model="dateSelected"
            no-title
            :first-day-of-week="1"
            locale="es-cl"
            @input="selectDate()"></v-date-picker>

          </v-menu>

          <v-divider vertical></v-divider>

          <copiar-tarjas
          class="d-none d-md-inline-block"
          label="copiar"
          :trabajadores="trabajadores"
          @onCopy="onCopyTarjas"
          color="white white--text"
          :fecha-destino="dateSelected"
          ></copiar-tarjas>

          <v-divider vertical ></v-divider>

          <select-personas
          class=""
          :fullscreen="isMobile"
          :personas="trabajadores"
          :disabled="disabledTrabajadores"
          @selected="selectTrabajadoresDone"
          label="+ tarja"
          color="white"
          ></select-personas>

          <v-divider vertical ></v-divider>

          <!--
          <v-divider vertical ></v-divider>
            <v-btn color="white" text @click="showAsistencias()" class="">
              Asistencias
            </v-btn>
        -->

        </v-toolbar-items>

          <v-spacer></v-spacer>

        <v-toolbar-items>

          <!--
          <v-menu offset-y v-if="groupBy">
            <template v-slot:activator="{ on }">
              <v-btn
              class="d-none d-md-flex"
              text
              v-on="on"
              >
              {{groupBy.name || "Agrupar por"}} <v-icon right>arrow_drop_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
            v-for="(grupo, index) in groupsList"
            :key="index"
            @click="groupBy = grupo"
            >
            <v-list-item-title>{{ grupo.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
          -->

          


        </v-toolbar-items>

    </template>




      <template v-else>
        <v-btn small text color="white" class="mr-2"  @click="validateSelected()">
          <v-icon left>check_circle</v-icon>
          validar
        </v-btn>
        <v-btn small text color="white" class="mr-2"  @click="validateSelected(false)">
          <v-icon left >cancel</v-icon>
          invalidar
        </v-btn>
        <!-- <v-btn small text color="white" class="mr-2"> <v-icon left>file_copy</v-icon> copiar </v-btn> -->
        <v-btn :loading="loadingDeleteSelected" small text color="white" @click="deleteSelected()">
          <v-icon left>delete</v-icon>
          borrar
        </v-btn>

        <v-spacer></v-spacer>

        <v-toolbar-title class="pa-2 subtitle-1">{{tarjasSelected.length}} Tarjas Seleccionadas</v-toolbar-title>
        <v-btn icon text color="white" @click="cancelSelected()">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-toolbar>

    </v-flex>








    <v-flex xs12>

      <list-tarjas
      :date-selected="dateSelected"
      :key="keyLista"
      ref="listTarjas"
      :groupBy="groupBy"
      :tarjaDefault="tarjaDefault"
      :tarjas="tarjas"
      :loading="loadingDate || loading"
      :contratos="contratos"
      :tipos-contrato="tiposContrato"
      :centrosCosto="centrosCosto"
      :labores="sublabores"
      :trabajadores="trabajadores"
      :asistencias="asistencias"
      v-model="tarjasSelected"
      @change="changeList"
      ></list-tarjas>

      </v-flex>





      <!--

      <v-layout row justify-center>
        <v-dialog v-model="dialogAsistencia" transition="dialog-bottom-transition" :overlay="false" eager>
          <v-card>
            <v-toolbar dark color="primary" dense>
              <v-toolbar-title>Asistencias</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
              <v-btn icon @click.native="dialogAsistencia = false" dark>
                <v-icon>close</v-icon>
              </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <asistencia
              :trabajadores="trabajadores"
            ></asistencia>
          </v-card>
        </v-dialog>
      </v-layout>

    -->





  </v-layout>

</template>
<script>

//dependencies
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';

//components
import listTarjas from "@/components/listTarjasNative"
import selectPersonas from "@/components/selectPersonas"
import copiarTarjas from "@/components/copiarTarjas"

//models
import tarjaModel from "@/models/tarjaModel";
import centrosCostoModel from "@/models/centrosCostoModel";
import trabajadorModel from "@/models/trabajadorModel";
import laborModel from "@/models/laborModel";
import subLaborModel from "@/models/subLaborModel";
import tipoContratoModel from "@/models/tipoContratoModel";

export default {
  name: "tarjasView",
  components: {
    listTarjas,
    selectPersonas,
    copiarTarjas
  },
  data: () => ({
    tarjas         : [],
    contratos      : [],//obtenido de la peticion de tarjas
    tiposContrato  : [],
    keyLista       : 1,
    tarjasSelected : [],
    campos: [],
    tarjaDefault   : {
      asistencia_id   : null,
      centro_costo_id : null,
      sub_labor_id    : null,
      trabajador_id   : null,
      trabajador      : null,
      horas_extras    : null,
      jornada         : null,
      rendimiento     : null,
      valor_total     : null,
      valor_unidad    : null,
      bono            : null,
      dia             : 1
    },
    groupsList: [
      {name : "Sin orden",      key : null,               by : null},
      {name : "Por Trabajador", key : "trabajador.id",    by : "trabajador"},
      {name : "Por Labor",      key : "sublabor.id",      by : "sublabor"},
      {name : "Por Cuartel",    key : "centrosCosto.id",  by : "centrosCosto"},
    ],
    groupBy               : null,
    //dateSelected          : "2020-01-15",//TEST
    dateSelected          : moment(new Date()).format("YYYY-MM-DD"),
    today                 : moment(new Date()).startOf('day'),
    loading               : true,
    loadingDate           : false,
    loadingOtherDate      : false,
    loadingNextDate       : false,
    loadingPrevtDate      : false,
    loadingDeleteSelected : false,
    dateMenu              : false,
    disabledTrabajadores  : [],
    dialogAsistencia      : false,
    //diffTime             : 0,

    centrosCosto  : [],
    trabajadores  : [],
    labores       : [],
    sublabores    : [],
    asistencias   : [],
    errorMsgModel : {
      jornada      : false,
      valor_total  : false,
      trabajador   : false,
      sublabor     : false,
      centrosCosto : false,
    }
  }),
  computed:{
    isToday(){
      return this.today.diff(moment(this.dateSelected), "hours") == 0;
    },
    isPast(){
      return this.today.diff(moment(this.dateSelected), "hours") > 0;
    },
    isFuture(){
      return this.today.diff(moment(this.dateSelected), "hours") < 0;
    },
    dateSelectedFormated(){
      return moment(this.dateSelected).format("DD MMM");
    },
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
  },

  watch:{
    empresaSelected(){
      if(this.empresaSelected){
        //console.log("watch empresaSelected ");
        this.getAllData();
      }
    }
  },
  created() {
    //console.log("created");
    this.groupBy = this.groupsList[1];
  },
  mounted() {
    //console.log("mounted");
    //do something after mounting vue instance
    this.getAllData();
  },
  methods: {
    getAllData(){
      this.loading = true;
      //console.log("getAllData");
      if(this.empresaSelected !== null){

        axios.all([
          this.getTarjas(),
          this.getTipoContratos(),
          this.getCentrosCosto(),
          this.getLabores(),
          this.getSubLabores(),
          //this.getAsistencias(),
          this.getTrabajadores(),
        ]).then(res => {
          this.prepareLabores();
          this.prepareContratos();
          this.prepareTarjas();
          this.keyLista++;
          this.loading = false;
        }, function(resError){
          console.error(resError);
          this.loading = false;
        })

      }else{
        //console.log("getAllData: empresa no selected");
      }
    },
    changeDate(diff) {
      //console.log("changeDate");
      this.loadingDate = true;
      if(diff > 0){
        this.loadingNextDate = true;
      }else if (diff < 0) {
        this.loadingPrevtDate = true;
      }else{
        this.loadingOtherDate = true;
      }
      var newDate = moment(this.dateSelected).add(diff, "days").format("YYYY-MM-DD");
      this.dateSelected = newDate;
      this.refreshTarjas();
    },
    selectDate(){
      this.dateMenu         = false;
      this.loadingDate      = true;
      this.loadingOtherDate = true;
      this.refreshTarjas();
    },
    prepareLabores(){
      _.forEach(this.sublabores, sub => {
        sub.labor = _.find(this.labores, {id: sub.labor_id});
        sub.codname = sub.nombre;
        if(sub.codigo && sub.codigo.length > 1){
          sub.codname = sub.codigo;
        }
      });
      _.forEach(this.labores, labor => {
        labor.sublabores = _.filter(this.sublabores, sub => {
          return sub.labor_id == labor.id;
        })
      });
    },

    prepareContratos(){
      //console.log("prepareContratos");
      _.forEach(this.contratos, contrato => {
        contrato.tipoContrato = _.find(this.tiposContrato , {id: contrato.tipo_contrato_id});
      })
      _.forEach(this.trabajadores, tr => {
        tr.contrato = _.find(this.contratos, {trabajador_id: tr.id});
      })
    },

    prepareTarjas(){
      //console.log("prepareTarjas");
      _.forEach(this.tarjasOriginal, tarja => {
        this.prepareTarja(tarja);
      });
      this.tarjas = _.cloneDeep(this.tarjasOriginal);
      //console.log("prepareTarjas DONE");
    },
    prepareTarja(tarja){
        tarja.centrosCosto  = _.find(this.centrosCosto, {id: tarja.centro_costo_id});
        tarja.asistencia    = _.find(this.asistencias, {id: tarja.asistencia_id});
        tarja.sublabor      = _.find(this.sublabores , {id: tarja.sub_labor_id});
        tarja.trabajador    = _.find(this.trabajadores , {id: tarja.trabajador_id});
        tarja.isNew         = false;
        tarja.isEdit        = false;
        tarja.loading       = false;
        tarja.error         = false;
        tarja.key           = 0;
        tarja.dia           = tarja.dia;
        tarja.errorMsg      = _.clone(this.errorMsgModel);

        tarja.cleanErrorMsg = function(tarja){
          tarja.errorMsg     = _.clone(this.errorMsgModel);
        }.bind(this)

        if(tarja.dia === undefined){
          tarja.dia = 1;
        }

        if (tarja.validada_por && tarja.validada_por.updated_at) {
          tarja.validada_por.updated_at_formated = moment.utc(tarja.validada_por.updated_at).local().format("HH:mm , DD [de] MMMM, YYYY")
        }
        if(tarja.horas_extras == 0){
          tarja.horas_extras = null;
        }
        if(tarja.valor_unidad == 0){
          tarja.valor_unidad = null;
        }
        if(tarja.bono == 0){
          tarja.bono = null;
        }
        if(tarja.rendimiento == 0){
          tarja.rendimiento = null;
        }


    },

    changeList(tarjas){
      //this.refreshTarjas(tarjas);
    },

    refreshTarjas(tarjasNuevas){ // << tarjas incluye las tarjas para hacer update y las tarjas nuevas

      // TODO: considerar tarjas nuevas isNew=true , ya que no estan guardadas
      if(tarjasNuevas){
        var tarjasNew = _.filter(tarjasNuevas, {isNew: true});
      }

      return this.getTarjas().then(res => {
        this.prepareContratos();
        this.prepareTarjas();
        if(tarjasNew){
          this.tarjas = this.tarjas.concat(tarjasNew);
        }
        this.keyLista++;
      })
    },
    onCopyTarjas(){
      this.refreshTarjas();
    },
    getTarjas(){
      var self = this;
      //console.log("getTarjas");
      var p = tarjaModel.all({params:{
        empresa_id : self.empresaSelected.id,
        fecha_inicio      : self.dateSelected,
      }})
      p.then(res => {
        //console.log("getTarjas DONE");
        self.loadingDate      = false;
        self.loadingOtherDate = false;
        self.loadingNextDate  = false;
        self.loadingPrevtDate = false;
        self.tarjasOriginal   = res.data.data.tarjas;
        self.contratos        = res.data.data.contratos;
      }, resError =>{
        console.error(resError);
      });
      return p;
    },

    selectTrabajadoresDone(trabajadores){
      //console.log("selectTrabajadoresDone");
      trabajadores.forEach(trabajador => {
        var newTarja           = _.clone(this.tarjaDefault);
        newTarja.trabajador    = trabajador;
        newTarja.trabajador_id = trabajador.id;

        if(trabajador.contratistas && trabajador.contratistas.length > 0){
          newTarja.contratista_id = _.first(trabajador.contratistas).id;
        }

        this.prepareTarja(newTarja);
        newTarja.isNew   = true;
        trabajador.isNew = true;
        this.tarjas.push(newTarja);
        this.$refs.listTarjas.init();
      });
    },

    getTipoContratos(){
      //console.log("getTipoContratos");
      var p = tipoContratoModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }})
      p.then(res => {
      //console.log("getTipoContratos DONE");
        this.tiposContrato = res.data.data;
      }, resError =>{
        console.error(resError);
      });
      return p
    },

    getCentrosCosto(){
      //console.log("getCentrosCosto");
      var p = centrosCostoModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }})
      p.then(res => {
        //console.log("getCentrosCosto DONE");
        this.centrosCosto = res.data.data;
        _.forEach(this.centrosCosto, cc => {
          cc.codname = cc.nombre;
          if(cc.codigo && cc.codigo.length > 1){
            cc.codname = cc.codigo;
          }
        })
      }, resError =>{
        console.error(resError);
      });
      return p
    },

    getLabores(){
      //console.log("getLabores");
      var p = laborModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
        //console.log("getLabores DONE");
        this.labores = res.data.data;
      }, resError =>{
        console.error(resError);
      });
      return p;
    },


    getSubLabores(){
      //console.log("getSubLabores");
      var p = subLaborModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
        //console.log("getSubLabores DONE");
        this.sublabores = _.flatMap(res.data.data, data=>{
          return data
        });
      }, resError =>{
        console.error(resError);
      });
      return p;
    },

/*
    getAsistencas(){
      //console.log("getAsistencias");
      var p = AsistenciaModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
        //console.log("getAsistencias DONE");
        this.asistencias = res.data.data;
      }, resError =>{
        console.error(resError);
      });
      return p;
    },
    */
    getTrabajadores(){
      return trabajadorModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }}).then(res => {
        this.trabajadores = res.data.data;
        _.forEach(this.trabajadores, tr => {
          tr.codname = tr.nombre;
          if(tr.codigo && tr.codigo.length > 1){
            tr.codname = tr.codigo;
          }
        })
        return res;
      }, resError => console.error(resError));
    },

    showAsistencias(){
      this.dialogAsistencia = true;
    },



    cancelSelected(){
      this.tarjasSelected = [];
    },
    deleteSelected(){
      var self = this;
      if(confirm("Seguro quiere eliminar las tarjas seleccionadas")){
        self.loadingDeleteSelected = true;
        var promises = [];
        var indexRemove = [];
        _.forEach(self.tarjasSelected, (tarja, index) => {
          if(tarja.id){
            promises.push(tarjaModel.delete(tarja.id));
          }
        })

        Promise.all(promises).then(res => {
          self.refreshTarjas().then(res => {
            self.loadingDeleteSelected = false;
            self.tarjasSelected = [];
          });
        }, resError => {
          console.error(resError);
        })
      }
    },


    validateSelected(validate = true){
      var self = this;
      if(confirm("Seguro quiere validar las tarjas seleccionadas")){
        self.loadingDeleteSelected = true;
        var promises               = [];
        var indexRemove            = [];
        _.forEach(self.tarjasSelected, (tarja, index) => {
          if(tarja.id){
            promises.push(self.validateTarja(tarja, validate));
          }
        })

        Promise.all(promises).then(res => {
          self.refreshTarjas().then(res => {
            self.loadingDeleteSelected = false;
            self.tarjasSelected = [];
          });
        }, resError => {
          console.error(resError);
        })
      }
    },

    validateTarja(tarja, validate = true){
      var self = this;
      var user = self.$store.getters.user;
      var d    = {
          id               : tarja.id,
          fecha            : tarja.fecha ? moment(tarja.fecha).format("YYYY-MM-DD") : this.dateSelected,
          jornada          : tarja.jornada || 0,
          rendimiento      : tarja.rendimiento || 0,
          valor_unidad     : tarja.valor_unidad || 0,
          horas_extras     : tarja.horas_extras || 0,
          bono             : tarja.bono || 0,
          dia              : tarja.dia,
          valor_total      : 0,
          valor_dia        : tarja.trabajador.contrato.valor_dia,
          valor_hora_extra : tarja.trabajador.contrato.hora_extra,
          trabajador_id    : tarja.trabajador.id,
          sub_labor_id     : tarja.sublabor.id,
          centro_costo_id  : tarja.centrosCosto.id,
          validada_por     : validate ? user.id : null
        };


        if(tarja.rendimiento){
          d.rendimiento = tarja.rendimiento;
        }

        if(tarja.contratista_id){
          d.contratista_id = tarja.contratista_id;
        }
        return tarjaModel.saveOrAdd(d).then(()=>{
          tarja.error = true;
        }, ()=>{
          tarja.error = true;
          console.error("problema al validar tarja");
        });
    }





  }


}
</script>
<style lang="scss" >
</style>
